import React, { useState } from 'react';
import { Helmet } from 'react-helmet';
import { BiFile, BiXCircle } from 'react-icons/bi';
import { FaAngleLeft, FaAngleRight } from 'react-icons/fa6';
import { db, storage } from '../../firebase';
import { getDownloadURL, ref, uploadBytes, uploadBytesResumable } from 'firebase/storage';
import { addDoc, collection, Timestamp } from 'firebase/firestore';
import { LuImagePlus } from 'react-icons/lu';
import { BsCheck2Circle } from 'react-icons/bs';
import { RxCrossCircled } from "react-icons/rx";
import Modal from '../../components/Modal/Modal';

const WeAreHiring = () => {

    const [step, setStep] = useState(0);

    const [name, setName] = useState('');
    const [location, setLocation] = useState('');
    const [email, setEmail] = useState('');
    const [phone, setPhone] = useState('');
    const [role, setRole] = useState('');
    const [whyYou, setWhyYou] = useState('');
    const [story, setStory] = useState('');
    const [problems, setProblems] = useState('');
    const [characteristics, setCharacteristics] = useState('');
    const [socialMediaHandle, setSocialMediaHandle] = useState('');
    const [expectedCompensation, setExpectedCompensation] = useState('');

    const [tools, setTools] = useState('');
    const [skills, setSkills] = useState([]);
    const [experience, setExperience] = useState('');



    const [picture, setPicture] = useState(null);
    const [video, setVideo] = useState(null);
    const [files, setFiles] = useState([]);
    const [fileUrls, setFileUrls] = useState([]);

    const skillsOptions = [
        { id: 1, data: { nom: "Conceptualisation" } },
        { id: 2, data: { nom: "Définition du MVP" } },
        { id: 3, data: { nom: "Storyboard" } },
        { id: 4, data: { nom: "Recherche" } },
        { id: 5, data: { nom: "Parcours produit" } },
        { id: 6, data: { nom: "Schémas / Diagrammes" } },
        { id: 7, data: { nom: "Design UX" } },
        { id: 8, data: { nom: "Animation de brainstorming & d’ateliers" } },
        { id: 9, data: { nom: "Design UI" } },
        { id: 10, data: { nom: "Prototypage" } },
        { id: 11, data: { nom: "Architecture de l’information" } },
        { id: 12, data: { nom: "Design responsive" } },
        { id: 13, data: { nom: "Narration visuelle" } },
        { id: 14, data: { nom: "Création d’identité de marque" } },
        { id: 15, data: { nom: "Production de contenus graphiques" } },
        { id: 16, data: { nom: "Développement de guides de style" } },
        { id: 17, data: { nom: "Design imprimé" } },
        { id: 18, data: { nom: "Communication" } },
        { id: 19, data: { nom: "Réception et intégration de feedbacks" } },
        { id: 20, data: { nom: "Travail en équipe" } },
        { id: 21, data: { nom: "Engagement communautaire" } },
        { id: 22, data: { nom: "Résolution de problèmes" } },
        { id: 23, data: { nom: "Adaptabilité" } },
        { id: 24, data: { nom: "Sens du détail" } },
        { id: 25, data: { nom: "Apprentissage continu" } },
        { id: 26, data: { nom: "Analyse de données" } },
        { id: 27, data: { nom: "Rédaction publicitaire (Copywriting)" } },
        { id: 28, data: { nom: "Veille des tendances" } },
        { id: 29, data: { nom: "Wireframing (maquettes filaires)" } },
        { id: 30, data: { nom: "Automatisation" } },
        { id: 31, data: { nom: "Design 3D" } },
        { id: 32, data: { nom: "Tests A/B" } },
        { id: 33, data: { nom: "Visualisation de données" } },
        { id: 34, data: { nom: "Cartographie du parcours client" } },
        { id: 35, data: { nom: "Stratégie marketing" } },
        { id: 36, data: { nom: "Animations graphiques" } },
        { id: 37, data: { nom: "Publicité digitale" } },
        { id: 38, data: { nom: "Développement web no-code" } },
        { id: 39, data: { nom: "Gestion des réseaux sociaux" } },
        { id: 40, data: { nom: "Montage vidéo" } },
        { id: 41, data: { nom: "Tests d’utilisabilité" } },
        { id: 42, data: { nom: "Stratégie de contenu" } },
        { id: 43, data: { nom: "Montage audio" } },
        { id: 44, data: { nom: "Illustration" } },
        { id: 45, data: { nom: "Typographie" } },
        { id: 46, data: { nom: "Théorie des couleurs" } },
        { id: 47, data: { nom: "Design mobile" } },
        { id: 48, data: { nom: "Tests utilisateurs" } },
        { id: 49, data: { nom: "Optimisation SEO" } },
        { id: 50, data: { nom: "Design d’interaction" } },
        { id: 51, data: { nom: "Design multiplateforme" } },
    ];


    const [loading, setLoading] = useState(false);

    const handlePicture = (event) => {
        const file = event.target.files[0];
        if (file) {
            setPicture({
                file,
                preview: URL.createObjectURL(file)
            });
        }
    };

    const removePicture = () => {
        setPicture(null);
    };

    const handleVideo = (event) => {
        const file = event.target.files[0];
        if (file) {
            setVideo({
                file,
                preview: URL.createObjectURL(file)
            });
        }
    };

    const removeVideo = () => {
        setVideo(null);
    };

    const handleNextStep = () => {
        const form = document.getElementById("weAreHiringForm");
        if (form.reportValidity()) {
            setStep(step + 1);
        }
    };


    // Gestion des fichiers sélectionnés
    const handleFiles = (event) => {
        const selectedFiles = Array.from(event.target.files);

        const newFiles = selectedFiles.map((file) => ({
            file, // fichier brut
            preview: URL.createObjectURL(file), // preview pour affichage
            name: file.name, // nom original
        }));

        // On fusionne avec l’existant
        setFiles((prev) => [...prev, ...newFiles]);
    };

    // Supprimer un fichier du tableau
    const removeFile = (index) => {
        setFiles((prev) => {
            // libérer l’URL pour éviter fuites mémoire
            URL.revokeObjectURL(prev[index].preview);
            return prev.filter((_, i) => i !== index);
        });
    };

    // Upload des fichiers
    const uploadFiles = async (projectName) => {
        const urls = [];
        const timestamp = Date.now();
        const safeProjectName = projectName.trim().replace(/\s+/g, '_').toLowerCase();

        for (let i = 0; i < files.length; i++) {
            const { file } = files[i]; // récupérer le vrai fichier
            const extension = file.name.split('.').pop();
            const customFileName = `wearehiring_${safeProjectName}_${timestamp}_${i + 1}.${extension}`;

            const storageRef = ref(storage, `wearehiring/${customFileName}`);
            const uploadTask = uploadBytesResumable(storageRef, file);

            await new Promise((resolve, reject) => {
                uploadTask.on(
                    "state_changed",
                    null,
                    (error) => reject(error),
                    async () => {
                        const downloadURL = await getDownloadURL(uploadTask.snapshot.ref);
                        urls.push(downloadURL);
                        resolve();
                    }
                );
            });
        }

        setFileUrls(urls);
        return urls;
    };

    const [open, setOpen] = useState(false);

    const [modalMessage, setModalMessage] = useState("");
    const [modalType, setModalType] = useState("success"); // "success" ou "error"

    // Ouvrir le modal
    const handleOpen = (type, message) => {
        setModalType(type);
        setModalMessage(message);
        setOpen(true);
    };

    // Fermer le modal
    const handleClose = () => {
        setOpen(false);
        setModalMessage("");
    };


    // handleSubmit
    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        try {
            let pictureUrl = "";
            let videoUrl = "";

            if (picture?.file) {
                const storageRef = ref(storage, `wearehiring/${Date.now()}_${picture.file.name}`);
                await uploadBytes(storageRef, picture.file);
                pictureUrl = await getDownloadURL(storageRef);
            }

            if (video?.file) {
                const storageRef = ref(storage, `wearehiring/${Date.now()}_${video.file.name}`);
                await uploadBytes(storageRef, video.file);
                videoUrl = await getDownloadURL(storageRef);
            }

            const uploadedFiles = await uploadFiles(name);

            await addDoc(collection(db, "wearehiring"), {
                name,
                location,
                email,
                phone,
                role,
                whyYou,
                story,
                problems,
                pictureUrl,
                characteristics,
                socialMediaHandle,
                expectedCompensation,
                tools,
                skills,
                experience,
                files: uploadedFiles,
                videoUrl,
                createdAt: Timestamp.now(),
            });

            handleOpen("success", "Votre candidature a été envoyée avec succès !");

            // Révoquer les URLs pour libérer mémoire
            files.forEach(f => URL.revokeObjectURL(f.preview));
            if (picture?.preview) URL.revokeObjectURL(picture.preview);
            if (video?.preview) URL.revokeObjectURL(video.preview);

            // Reset form
            setName("");
            setLocation("");
            setEmail("");
            setPhone("");
            setRole("");
            setWhyYou("");
            setStory("");
            setProblems("");
            setPicture(null);
            setCharacteristics("");
            setSocialMediaHandle("");
            setExpectedCompensation("");
            setTools("");
            setSkills([]);
            setExperience("");
            setFiles([]);
            setVideo(null);
            setStep(0);

        } catch (error) {
            console.error("Erreur lors de l’envoi :", error);
            handleOpen("error", "Une erreur est survenue 😢 Veuillez réessayer.");
        } finally {
            setLoading(false);
        }
    };
    return (
        <>
            <Helmet>
                <title>{`WEAREBIAM | HIRING`}</title>
                <meta
                    name="description"
                    content={'WEAREHIRING'}
                />

                {/* Open Graph tags */}
                <meta property="og:title" content={`WEAREBIAM | HIRING`} />
                <meta
                    property="og:description"
                    content={'WEAREHIRING'}
                />
                <meta property="og:image" content="https://firebasestorage.googleapis.com/v0/b/werebiam.firebasestorage.app/o/assets%2Fwebcover_bw.png?alt=media&token=f4086ce5-b347-4f99-8b23-0f52d461675c" />
                <meta property="og:url" content={`https://wearebiam.com/wearehiring`} />
                <meta property="og:type" content="website" />
            </Helmet>

            <div className="flex items-center justify-center bg-white w-full">
                <div className='flex flex-col items-center max-w-[1440px] gap-[30px] w-full min-h-screen bg-white lg:p-[5rem] p-[1.25rem]'>

                    <div className="flex flex-col gap-10 lg:w-[700px] ppmori lg:mt-[50px] mt-[100px]">

                        <div className="flex flex-col gap-5">
                            <p className="text-black lg:text-[40px] text-[24px]">Join Our Team !</p>
                        </div>

                        {step > 0 && (
                            <button
                                type="button"
                                onClick={() => setStep(step - 1)}
                                className="flex items-center gap-2 py-2 rounded-lg bg-white text-black w-fit"
                            >
                                <FaAngleLeft /> Back
                            </button>
                        )}

                        <form className='flex flex-col gap-10' id='weAreHiringForm' onSubmit={handleSubmit}>

                            {step === 0 && (
                                <>
                                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">What is your name? *</label>
                                            <input type="text" id="name" value={name} onChange={(e) => setName(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>

                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Where are you from? *</label>
                                            <input type="text" id="location" value={location} onChange={(e) => setLocation(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Your email *</label>
                                            <input type="email" id="email" value={email} onChange={(e) => setEmail(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>

                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Your phone number *</label>
                                            <input placeholder='+22899711712' type="number" id="phone" value={phone} onChange={(e) => setPhone(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">What role fits you best? *</label>
                                            <input type="text" id="role" value={role} onChange={(e) => setRole(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>

                                    </div>

                                    <div className="grid grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Explain why are you the right person for this position*</label>
                                            <textarea id="whyYou" value={whyYou} onChange={(e) => setWhyYou(e.target.value)} required className="min-h-[100px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Explain your story & what you have done in the past *</label>
                                            <textarea id="story" value={story} onChange={(e) => setStory(e.target.value)} required className="min-h-[100px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">What are some of the problems you have dealt with & how did you solve them. *</label>
                                            <textarea id="problems" value={problems} onChange={(e) => setProblems(e.target.value)} required className="min-h-[100px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className="flex flex-col gap-2.5">
                                        <label className="text-black lg:text-[20px]  text-[18px]">Please upload a picture of yourself</label>

                                        <div className="relative border-2 border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-white transition-all">
                                            <input
                                                type="file"
                                                onChange={handlePicture}
                                                accept="image/*"
                                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                            />
                                            <p className="text-gray-500">Click to choose a file or drag here</p>
                                        </div>


                                        {picture && (
                                            <div className="relative mt-4 w-full max-w-md mx-auto">
                                                <img
                                                    src={picture.preview}
                                                    alt="CandidatePicture preview"
                                                    className="w-full rounded-lg shadow-lg object-cover"
                                                />
                                                <button
                                                    onClick={removePicture}
                                                    className="absolute top-2 right-2 bg-black text-white p-1.5 rounded-full shadow-lg hover:bg-red-600 transition"
                                                >
                                                    <BiXCircle size={20} />
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Describe yourself in three characteristics*</label>
                                            <input type="text" id="characteristics" value={characteristics} onChange={(e) => setCharacteristics(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>

                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">What is your social media handle? *</label>
                                            <input type="text" id="socialMediaHandle" value={socialMediaHandle} onChange={(e) => setSocialMediaHandle(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className="grid lg:grid-cols-2 grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Expected Compensation (Range) *</label>
                                            <input type="text" id="expectedCompensation" value={expectedCompensation} onChange={(e) => setExpectedCompensation(e.target.value)} required className="h-[40px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>

                                    </div>

                                    <div className="flex mt-10">
                                        <button
                                            type="button"
                                            onClick={handleNextStep}
                                            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-black text-white"
                                        >
                                            Next Step <FaAngleRight />
                                        </button>
                                    </div>

                                </>
                            )}


                            {step === 1 && (
                                <>
                                    <div className="grid grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">What tools are you currently familiar with? *</label>
                                            <textarea id="tools" value={tools} onChange={(e) => setTools(e.target.value)} required className="min-h-[100px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className='form-ctrl flex flex-col gap-2.5'>
                                        <label className='text-black lg:text-[20px] text-[18px]'>What skills do you currently possess? *</label>
                                        <div className="flex flex-wrap gap-3">
                                            {skillsOptions.map((skillsOption) => {
                                                const skillsName = skillsOption.data.nom;
                                                return (
                                                    <label key={skillsOption.id} className="flex items-center gap-2 cursor-pointer">
                                                        <input
                                                            type="checkbox"
                                                            value={skillsName}
                                                            checked={skills.includes(skillsName)}
                                                            onChange={(e) => {
                                                                if (e.target.checked) {
                                                                    setSkills([...skills, skillsName]);
                                                                } else {
                                                                    setSkills(skills.filter(item => item !== skillsName));
                                                                }
                                                            }}
                                                            className="w-4 h-4 accent-purple-600"
                                                        />
                                                        <span className=" text-black">{skillsName}</span>
                                                    </label>
                                                );
                                            })}
                                        </div>
                                    </div>

                                    <div className="grid grid-cols-1 gap-5">
                                        <div className="flex flex-col gap-2.5">
                                            <label className="text-black lg:text-[20px]  text-[18px]">Share relevant working experience (please share as much as you can, visuals and links) *</label>
                                            <textarea id="experience" value={experience} onChange={(e) => setExperience(e.target.value)} required className="min-h-[100px] py-0 px-2.5 rounded-lg text-black border-2 border-gray-300" />
                                        </div>
                                    </div>

                                    <div className="">

                                        <label className="text-black lg:text-[20px] text-[18px]">Feel free to add any other files/work</label>
                                        {/* Zone de drop pour tous types de fichiers */}
                                        <div className="relative border-2 border-dashed border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-purple-500 transition-all">
                                            <input
                                                type="file"
                                                multiple
                                                onChange={handleFiles}
                                                accept=".jpg,.jpeg,.png,.gif,.pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt"
                                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                            />
                                            <div className="flex flex-col items-center text-gray-500">
                                                <LuImagePlus size={40} className="mb-2" />
                                                <p className="text-sm">Click to choose a file or drag here</p>
                                                <p className="text-xs text-gray-400">(Images, PDF, Word, Excel...)</p>
                                            </div>
                                        </div>

                                        {/* Affichage des fichiers sélectionnés */}
                                        {files.length > 0 && (
                                            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 mt-6">
                                                {files.map((file, index) => (
                                                    <div
                                                        key={index}
                                                        className="relative group flex flex-col items-center border rounded-lg p-2 shadow-md bg-white"
                                                    >
                                                        {/* Vérification si c'est une image */}
                                                        {file?.type && file.type.startsWith("image/") ? (
                                                            <img
                                                                src={file.preview}
                                                                alt={`Preview ${index}`}
                                                                className="w-full h-24 object-cover rounded-lg transition-transform transform group-hover:scale-105"
                                                            />
                                                        ) : (
                                                            <div className="flex flex-col items-center justify-center w-full h-24 text-gray-600">
                                                                <BiFile size={40} />
                                                                <span className="text-xs mt-1 truncate w-full text-center">
                                                                    {file?.name || "Unknown file"}
                                                                </span>
                                                            </div>
                                                        )}

                                                        {/* Bouton de suppression */}
                                                        <button
                                                            className="absolute top-2 right-2 bg-black text-white p-1 rounded-full shadow-lg opacity-0 group-hover:opacity-100 transition"
                                                            onClick={() => removeFile(index)}
                                                        >
                                                            <BiXCircle size={20} />
                                                        </button>
                                                    </div>
                                                ))}
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex mt-10">
                                        <button
                                            type="button"
                                            onClick={handleNextStep}
                                            className="flex items-center gap-2 px-4 py-2 rounded-lg bg-black text-white"
                                        >
                                            Next Step <FaAngleRight />
                                        </button>
                                    </div>

                                </>
                            )}

                            {step === 2 && (
                                <>
                                    <div className="flex flex-col gap-5">
                                        <p className="text-black font-bold lg:text-[30px] text-[16px]">We feel humbled to have you here.</p>
                                        <p className="text-black lg:text-[16px] text-[12px]">
                                            <strong>
                                                Thank you for answering the questions so far -
                                            </strong>
                                            Please submit a video introducing yourself and explaining once again why you are the right fit for this position.
                                        </p>
                                    </div>

                                    <div className="flex flex-col gap-2.5">
                                        <label className="text-black lg:text-[20px]  text-[18px]">Upload the video here (Optional)</label>

                                        <div className="relative border-2 border-gray-300 rounded-lg p-6 text-center cursor-pointer hover:border-white transition-all">
                                            <input
                                                type="file"
                                                onChange={handleVideo}
                                                accept="video/*"
                                                className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                            />
                                            <p className="text-gray-500">Click to choose a file or drag here</p>
                                        </div>


                                        {video && (
                                            <div className="relative mt-4 w-full max-w-md mx-auto">
                                                <video
                                                    src={video.preview}
                                                    alt="CandidateVideo preview"
                                                    className="w-full rounded-lg shadow-lg object-cover"
                                                />
                                                <button
                                                    onClick={removeVideo}
                                                    className="absolute top-2 right-2 bg-black text-white p-1.5 rounded-full shadow-lg hover:bg-red-600 transition"
                                                >
                                                    <BiXCircle size={20} />
                                                </button>
                                            </div>
                                        )}
                                    </div>

                                    <div className="flex mt-10">
                                        <button
                                            type="submit"
                                            disabled={loading}
                                            className={`flex items-center justify-center gap-2 mt-5 py-2 px-4 rounded-lg w-fit transition
                                    ${loading ? "bg-gray-400 cursor-not-allowed" : "bg-black text-white"}`}
                                        >
                                            {loading ? (
                                                <div className="w-5 h-5 border-2 border-black border-t-transparent rounded-full animate-spin"></div>
                                            ) : (
                                                <>
                                                    Apply
                                                    <FaAngleRight />
                                                </>
                                            )}
                                        </button>
                                    </div>
                                </>
                            )}

                        </form>

                    </div>

                    {open && (
                        <Modal isOpen={open} onClose={handleClose}>
                            <center>
                                <div className="flex flex-col gap-4 items-center justify-center">
                                    {modalType === "success" ? (
                                        <BsCheck2Circle className="text-green-700 text-[50px]" />
                                    ) : (
                                        <RxCrossCircled className="text-red-700 text-[50px]" />
                                    )}

                                    <p>{modalMessage}</p>

                                    <button
                                        className="buttonviolet"
                                        type="button"
                                        onClick={handleClose}
                                    >
                                        OK
                                    </button>
                                </div>
                            </center>
                        </Modal>
                    )}

                </div>
            </div>
        </>
    )
}

export default WeAreHiring